import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';

import actions from 'frontend/state/actions';
import {
  SmallButton,
} from 'frontend/components';

const mapStateToProps = () => ({
  children: 'Run Sim Again',
  theme: 'success',
});

const mapDispatchToProps = (dispatch, props) => ({
  onClick: () => {
    const actionMap = {
      gear: actions.loadGearReport,
      talents: actions.loadTalentsReport,
      optimize: actions.loadOptimizeReport,
      droptimizer: actions.loadDroptimizerReport,
    };

    const action = actionMap[props.type];

    if (action) {
      dispatch(action(props.data));
    }

    const urlMap = {
      gear: '/simbot/gear',
      talents: '/simbot/talents',
      optimize: '/simbot/topgear',
      droptimizer: '/simbot/droptimizer',
    };

    const url = urlMap[props.type];
    if (url) {
      props.router.push(url);
    }
  },
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
});

const CopyTemplateButton = withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SmallButton));

CopyTemplateButton.propTypes = {
  type: PropTypes.string,
  data: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default CopyTemplateButton;
